//#region src/components/Skeleton/Skeleton.module.css
var e = "_container_1anm0_1", t = "_background_1anm0_10", n = "_pulse_1anm0_1", r = "_innerCircle_1anm0_23", i = {
	container: e,
	background: t,
	pulse: n,
	innerCircle: r
};
//#endregion
export { t as background, e as container, i as default, r as innerCircle, n as pulse };
